module.exports = function(successCallback, errorCallback) {
	require.ensure([], function() {
		successCallback(require("!!../../../node_modules/babel-loader/lib/index.js!./ReturnPolicy.js"));
	}, function() {
		if (errorCallback) errorCallback.apply(this, arguments);
	});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/split-chunk-loader?lazy!./src/StaticPage/Policy/ReturnPolicy.js
// module id = 1291
// module chunks = 58